import { render, staticRenderFns } from "./AppAddDeclarationSummary.vue?vue&type=template&id=3ab45244&scoped=true&"
import script from "./AppAddDeclarationSummary.vue?vue&type=script&lang=ts&"
export * from "./AppAddDeclarationSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AppAddDeclarationSummary.vue?vue&type=style&index=0&id=3ab45244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab45244",
  null
  
)

export default component.exports